import { AppState } from './reducers';

const getStorage = (): Storage => {
  // Usage of sessionStorage instead of localStorage to allow multiple instances of wep platform.
  return sessionStorage;
};

export const loadFromStorage = () => {
  try {
    let state = JSON.parse(getStorage().getItem('state') || '');
    // console.log('loadFromStorage: ', state);
    return state;
  } catch (err) {
    return undefined;
  }
};

export const saveToStorage = (state: AppState) => {
  // console.log('saveToStorage: ', state);
  try {
    const serializedState = JSON.stringify(state);
    getStorage().setItem('state', serializedState);
  } catch {
    // ignore write errors
  }
};
